import { parseCookies } from "nookies";
import { setPrevLocation } from "utils/routes/setPrevLocation";

type UsePrevLocationReturn = [string | undefined, (location: string) => void];

export const usePrevLocation = (): UsePrevLocationReturn => {
  const cookies = parseCookies();
  return [cookies.prev_location, setPrevLocation];
};
